module.exports = __webpack_public_path__ + "static/media/rajeev.4b751b47.jpg";